import type { Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';

import type { TabOrientation } from '../nativeTabsTypes.ts';

import { getTabAxis } from './tabOrientation.ts';

/** Drag-and-drop type identifier for native tab pills. */
export const NATIVE_TAB_TYPE = 'native-tab';

/** Returns the closest insertion edge for the configured tab orientation. */
export function computeClosestPillEdge(
	pointerPosition: number,
	wrappers: Array<HTMLElement | null>,
	orientation: TabOrientation = 'horizontal',
): { index: number; edge: Edge } | null {
	if (wrappers.length === 0) {
		return null;
	}

	const axis = getTabAxis(orientation);
	let closestIndex = 0;
	let closestEdge: Edge = axis.startEdge;
	let closestDistance = Infinity;

	wrappers.forEach((el, index) => {
		if (!el) {
			return;
		}
		const rect = el.getBoundingClientRect();
		const start = rect[axis.rectStart];
		const end = rect[axis.rectEnd];
		const startDistance = Math.abs(pointerPosition - start);
		const endDistance = Math.abs(pointerPosition - end);

		if (startDistance < closestDistance) {
			closestDistance = startDistance;
			closestIndex = index;
			closestEdge = axis.startEdge;
		}
		if (endDistance < closestDistance) {
			closestDistance = endDistance;
			closestIndex = index;
			closestEdge = axis.endEdge;
		}
	});

	return closestDistance === Infinity ? null : { index: closestIndex, edge: closestEdge };
}
